<template>
	<div>
		Login
	</div>
</template>

<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Login/Login.vue